import { twMerge } from 'tailwind-merge';
import { COLLECTION_VIEWS, type CollectionView } from '@witmetrics/unison-core';
import Title from '@/components/Title';
import NewDocumentMenuButton, {
  type NewDocumentMenuButtonProps,
} from '@/components/NewDocumentMenuButton';
import ExpandableSearch from '@/components/inputs/ExpandableSearch';
import ToggleBlock, { ToggleOption } from '@/components/ToggleBlock';
import { GridIcon, TableIcon } from '@/icons';
import { classes } from './utils';

export interface DocumentsHeaderProps extends NewDocumentMenuButtonProps {
  isFetchingData?: boolean;
  fileCollectionId?: number;
  collectionView: CollectionView;
  title?: string;
  search: string;
  onSearch: (search: string) => void;
  onChangeView: (view: CollectionView) => void;
  onSaveDocument: (fileID: number) => void;
}

export default function DocumentsHeader({
  isFetchingData,
  fileCollectionId,
  collectionView,
  title = 'Documents',
  search,
  onSearch,
  onChangeView,
  onCreateCollection,
  onSaveDocument,
}: DocumentsHeaderProps) {
  return (
    <div className={classes.wrapper}>
      <div className={classes.content}>
        <div className={classes.titlesWrapper}>
          <Title className={classes.title} size="sm">
            {title}
          </Title>
        </div>
        <div
          className={twMerge(
            classes.buttonsWrapper,
            isFetchingData && classes.disabled
          )}>
          <ExpandableSearch
            className={classes.search}
            variant="aurora"
            value={search}
            onChange={onSearch}
            onClose={() => onSearch('')}
          />
          <NewDocumentMenuButton
            fileCollectionId={fileCollectionId}
            onCreateCollection={onCreateCollection}
            onSaveDocument={onSaveDocument}
          />
        </div>
      </div>
      <div className={classes.toggleWrapper}>
        <ToggleBlock<CollectionView>
          className={classes.toggleBlock}
          value={collectionView}
          onChange={onChangeView}>
          <ToggleOption value={COLLECTION_VIEWS.LIST} tooltip="List View">
            <TableIcon className={classes.toggleIcon} />
          </ToggleOption>
          <ToggleOption value={COLLECTION_VIEWS.GRID} tooltip="Grid View">
            <GridIcon className={classes.toggleIcon} />
          </ToggleOption>
        </ToggleBlock>
      </div>
    </div>
  );
}
